import { Formik, FormikValues } from 'formik'
import * as yup from 'yup'
import styles from './RegistrationPage.module.css'
import s from '../../styles/common/Form.module.css'
import CustomInput from '../../components/UI/CustomInput/CustomInput'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import HeaderForAuth from '../../components/HeaderForAuth/HeaderForAuth'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { ChangeEvent, MouseEvent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Loader from '../../components/UI/Loader/Loader'
import { createRoleCompanyFromRuToEn } from '../../utils/createRoleForRegister'
import { waitTimer } from '../../utils/waitTimer'
import p from '../../components/UI/CustomInput/CustomInput.module.css'
import InputMask from 'react-input-mask'
import mainBackground from '../../assets/img/mainBackground.png'
import DropDown from '../../components/DropDown/DropDown'
import arrowDown from '../../assets/icons/arrowDownBlack.svg'
import usePasswordToggle from '../../hooks/usePasswordToggle'
import PATH from '../../navigation/path'
import { getDaDataCity, getDaDataCompany } from '../../redux/actions/daDataAction'
import { useMediaQuery } from 'react-responsive'
import { useDebounce } from '../../hooks/useDebounce'
import { registrationRequest } from '../../redux/actions/authAction'
import { clearError } from '../../redux/reducers/auth/authSlice'

// const dropDownOptions = ['Агент', 'Зал']
const dropDownOptions = ['Агент']

export interface Suggestion {
  data: {
    city: string
  }
}

function RegistrationPage() {
  const [PasswordInputType, ToggleIcon] = usePasswordToggle()
  const [open, setOpen] = useState(false)
  const [activeRole, setActiveRole] = useState('Выберите роль')
  const [city, setCity] = useState<string>('')
  const [citySuggestions, setCitySuggestions] = useState<Suggestion[]>([])
  const [inn, setInn] = useState<string>('')
  const [loader, setLoader] = useState(false)

  const debounced = useDebounce(inn, 400)

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })

  const { isLoading, error } = useAppSelector((state) => state.auth)
  const { daDataCity, daDataCompany } = useAppSelector((state) => state.daData)
  const [submittedValues, setSubmittedValues] = useState<any>(null)

  const [roleError, setRoleError] = useState('')
  const [cityError, setCityError] = useState('')

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const validationSchema = yup.object().shape({
    name: yup.string().required('Поле является обязательным'),
    address: yup.string().required('Поле является обязательным'),
    fullName: yup.string().required('Поле является обязательным'),
    phone: yup
      .string()
      .required('Поле является обязательным')
      .matches(
        /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/,
        'Неверный формат',
      ),
    email: yup
      .string()
      .transform((value) => value.trim())
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        'Почта введена некорректно, попробуйте еще раз',
      )
      .email('Почта введена некорректно, попробуйте еще раз')
      .required('Поле является обязательным'),
    password: yup
      .string()
      .transform((value) => value.trim())
      .required('Поле является обязательным')
      .min(8, 'Пароль должен содержать как минимум 8 символов')
      .matches(/^[^\u0400-\u04FF]+$/, 'Пароль не должен содержать кириллицу'),
  })

  const onActiveItem = (role: string) => {
    setActiveRole(role)
    setOpen(false)
  }

  const onOpenDropDown = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    setOpen(!open)
  }

  const handleCityInputChange = async (value: string) => {
    setCity(value)

    if (value.trim().length >= 1) {
      await dispatch(getDaDataCity({ query: value }))
    } else {
      setCitySuggestions([])
    }
  }

  const handleInnInputChange = (value: string) => {
    const numericValue = value.replace(/\D/g, '')
    const trimmed = numericValue.trim()
    setInn(trimmed)
    setSubmittedValues(null)
    if (trimmed.length < 10) {
      setCity('')
    }
  }

  const handleSelectSuggestion = (selectedCity: string) => {
    setCity(selectedCity)
    setCitySuggestions([])
  }

  const handleSubmitHandler = async (values: FormikValues) => {
    setSubmittedValues({ ...values, inn, city })
    const mobileWithoutSymbols = `+${values.phone.replace(/[\D]+/g, '')}`
    const role = createRoleCompanyFromRuToEn(activeRole)

    if (activeRole === 'Выберите роль') {
      setRoleError('Пожалуйста выберите роль вашей организации')
      waitTimer(() => setRoleError(''))
      return
    }

    if (city === '') {
      setRoleError('')
      setCityError('Пожалуйста выберите город вашей организации')
      waitTimer(() => setCityError(''))
      return
    }

    if (daDataCompany.suggestions.length === 0) {
      return
    }

    const resultAction = await dispatch(
      registrationRequest({
        role: role,
        contactPhone: mobileWithoutSymbols,
        city: city,
        address: values.address,
        contactFullName: values.fullName,
        companyName: values.name,
        inn: inn,
        email: values.email,
        password: values.password,
      }),
    )

    if (registrationRequest.rejected.match(resultAction)) {
      waitTimer(() => dispatch(clearError()))
    } else {
      setActiveRole('Выберите роль')
      navigate(PATH.registerConfirmation)
    }
  }

  useEffect(() => {
    if (debounced.length >= 10) {
      setLoader(true)
      dispatch(getDaDataCompany({ query: debounced }))
      const timer = setTimeout(() => {
        setLoader(false)
      }, 1000)

      return () => {
        clearTimeout(timer)
      }
    }
  }, [debounced, dispatch])

  useEffect(() => {
    setCitySuggestions(daDataCity)
  }, [daDataCity])

  useEffect(() => {
    if (
      daDataCompany?.suggestions?.length > 0 &&
      inn.length >= 10
    ) {
      const currentData = daDataCompany.suggestions[0]?.data
      const responseInn = currentData?.inn?.toString() ?? ''
      if (
        currentData &&
        responseInn === inn &&
        (currentData.name?.full || currentData.address?.value)
      ) {
        if (currentData.address?.data?.city) {
          setCity(currentData.address.data.city)
        }
        setSubmittedValues({
          name: currentData.name?.full ?? '',
          address: currentData.address?.value ?? '',
          fullName: currentData.management?.name ?? '',
          phone: '',
          email: '',
          password: '',
        })
      }
    }
  }, [daDataCompany?.suggestions, inn])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div
      className={styles.registrationPage}
      style={{
        background: `linear-gradient(90deg, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.00) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%), url(${mainBackground}), lightgray 50% / cover no-repeat`,
      }}
    >
      <div className={s.container}>
        <HeaderForAuth />
        <div className={styles.formContentBlock}>
          <h1 className={styles.whiteTitle}>Запрос на регистрацию</h1>
          <Formik
            key={
              submittedValues?.name
                ? `prefill-${inn}-${submittedValues.name}`
                : 'registration-form'
            }
            initialValues={
              submittedValues ?? {
                name: '',
                address: '',
                fullName: '',
                phone: '',
                email: '',
                password: '',
              }
            }
            validateOnBlur
            onSubmit={(values) => handleSubmitHandler(values)}
            validationSchema={validationSchema}
          >
            {(props) => {
              const { values, touched, errors, isValid, handleChange, handleBlur, handleSubmit } =
                props

              return (
                <div className={styles.formContainer}>
                  <div className={styles.leftBlock}>
                    <div className={styles.inputGroup}>
                      <div>
                        <h4 className={s.whiteSubtitle}>ИНН</h4>
                        <CustomInput
                          type='text'
                          placeholder='ИНН'
                          required
                          onChange={(e) => handleInnInputChange(e.target.value)}
                          value={inn.trim()}
                          className={
                            inn.length >= 10 &&
                            !loader &&
                            daDataCompany.suggestions.length === 0
                              ? `${s.inputError} ${s.input}`
                              : s.input
                          }
                        />
                        {loader && inn.length >= 10 && (
                          <div className={s.errorContainer}>
                            <p style={{ color: 'rgba(255, 255, 255, 0.8)', margin: 0 }}>
                              Поиск организации...
                            </p>
                          </div>
                        )}
                        {inn.length >= 10 &&
                          !loader &&
                          daDataCompany.suggestions.length === 0 && (
                            <div className={s.errorContainer}>
                              <p className={s.errorValidation}>
                                Организация с таким ИНН не найдена
                              </p>
                            </div>
                          )}
                      </div>
                      <div>
                        <h4 className={s.whiteSubtitle}>Название организации</h4>
                        <CustomInput
                          type='text'
                          placeholder='Название организации'
                          name='name'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.name}
                          className={errors.name && touched.name ? s.inputError : s.input}
                        />

                        {touched.name && errors.name && (
                          <div className={s.errorContainer}>
                            <p className={s.errorValidation}>{errors.name as string}</p>{' '}
                          </div>
                        )}
                      </div>
                      <div>
                        <h4 className={s.whiteSubtitle}>Город</h4>
                        <div className={styles.cityBlock}>
                          <CustomInput
                            type='text'
                            placeholder='Город'
                            name='city'
                            required
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              handleCityInputChange(e.target.value)
                            }
                            value={city}
                            className={cityError ? `${s.input} ${s.inputError}` : s.input}
                          />
                          <ul className={styles.suggestionsDropdown}>
                            {citySuggestions.map((suggestion: Suggestion, index: number) => (
                              <li
                                key={index}
                                onClick={() => handleSelectSuggestion(suggestion.data.city)}
                              >
                                {suggestion.data.city}
                              </li>
                            ))}
                          </ul>
                          {touched.city && errors.city && (
                            <div className={s.errorContainer}>
                              <p className={s.errorValidation}>{errors.city as string}</p>{' '}
                            </div>
                          )}
                        </div>
                      </div>
                      <div>
                        <h4 className={s.whiteSubtitle}>Адрес</h4>
                        <CustomInput
                          type='text'
                          placeholder='Адрес'
                          name='address'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.address}
                          className={errors.address && touched.address ? s.inputError : s.input}
                        />
                        {touched.address && errors.address && (
                          <div className={s.errorContainer}>
                            <p className={s.errorValidation}>{errors.address as string}</p>
                          </div>
                        )}{' '}
                      </div>
                      <div>
                        <h4 className={s.whiteSubtitle}>ФИО контактного лица</h4>
                        <CustomInput
                          type='text'
                          placeholder='ФИО контактного лица'
                          name='fullName'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.fullName}
                          className={errors.fullName && touched.fullName ? s.inputError : s.input}
                        />

                        {touched.fullName && errors.fullName && (
                          <div className={s.errorContainer}>
                            <p className={s.errorValidation}>{errors.fullName as string}</p>{' '}
                          </div>
                        )}
                      </div>
                    </div>
                    {!isMobile && (
                      <>
                        {roleError && (
                          <p className={`${s.errorValidation} ${s.networkError}`}>{roleError}</p>
                        )}
                        {cityError && (
                          <p className={`${s.errorValidation} ${s.networkError}`}>{cityError}</p>
                        )}
                        {error && (
                          <p className={`${s.errorValidation} ${s.networkError}`}>
                            {error || 'произошла серверная ошибка'}
                          </p>
                        )}
                      </>
                    )}
                  </div>

                  <div className={styles.rightBlock}>
                    <div className={styles.inputGroup}>
                      <div>
                        <h4 className={s.whiteSubtitle}>Номер телефона</h4>
                        <InputMask
                          mask='+7 (999) 999 9999'
                          type='phone'
                          placeholder='Номер телефона'
                          name='phone'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.phone}
                          className={
                            errors.phone && touched.phone
                              ? `${s.inputError} ${p.input}`
                              : `${s.input} ${p.input}`
                          }
                        ></InputMask>

                        {touched.phone && errors.phone && (
                          <div className={s.errorContainer}>
                            <p className={s.errorValidation}>{errors.phone as string}</p>{' '}
                          </div>
                        )}
                      </div>
                      <div>
                        <h4 className={s.whiteSubtitle}>Электронная почта/Логин</h4>
                        <CustomInput
                          type='text'
                          placeholder='Электронная почта/Логин'
                          name='email'
                          required
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email.trim()}
                          className={errors.email && touched.email ? s.inputError : s.input}
                        />

                        {touched.email && errors.email && (
                          <div className={s.errorContainer}>
                            <p className={s.errorValidation}>{errors.email as string}</p>{' '}
                          </div>
                        )}
                      </div>
                      <div>
                        <h4 className={s.whiteSubtitle}>Пароль</h4>
                        <div className={styles.passInput}>
                          <CustomInput
                            autoComplete={'new-password'}
                            type={PasswordInputType}
                            placeholder='Пароль'
                            name='password'
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password.trim()}
                            className={errors.password && touched.password ? s.inputError : s.input}
                          />
                          <div className={styles.eyeIcon}>{ToggleIcon}</div>
                        </div>
                        {touched.password && errors.password && (
                          <div className={s.errorContainer}>
                            <p className={s.errorValidation}>{errors.password as string}</p>
                          </div>
                        )}
                      </div>
                      <div>
                        <h4 className={s.whiteSubtitle}>Роль</h4>
                        <div
                          className={roleError ? `${styles.role} ${s.inputError}` : styles.role}
                          onClick={(e) => onOpenDropDown(e)}
                        >
                          <div className={styles.roleContainer}>
                            <div className={styles.roleText}>{activeRole}</div>
                            <img className={styles.roleIcon} src={arrowDown} alt='arrowDown' />
                          </div>
                          <DropDown className={styles.dropDown} open={open}>
                            {dropDownOptions.map((option, index) => {
                              return (
                                <div
                                  className={`${styles.dropDownItem} ${
                                    activeRole && styles.active
                                  }`}
                                  onClick={() => onActiveItem(option)}
                                  key={index}
                                >
                                  {option}
                                </div>
                              )
                            })}
                          </DropDown>
                        </div>
                      </div>
                    </div>
                    <div style={{ marginTop: 20 }} className={styles.buttonGroup}>
                      <CustomButton
                        title='К входу'
                        onClick={() => navigate(PATH.authPage)}
                        type='submit'
                        className={styles.navBtn}
                      />
                      <CustomButton
                        title='Отправить'
                        disabled={!isValid}
                        onClick={() => handleSubmit()}
                        type='submit'
                        className={styles.submitBtn}
                      />
                    </div>
                  </div>

                  {isMobile && (
                    <div className={styles.mobileBtnsBlock}>
                      {roleError && (
                        <p className={`${s.errorValidation} ${s.networkError}`}>{roleError}</p>
                      )}
                      {cityError && (
                        <p className={`${s.errorValidation} ${s.networkError}`}>{cityError}</p>
                      )}
                      {error && <p className={`${s.errorValidation} ${s.networkError}`}>{error}</p>}
                    </div>
                  )}
                </div>
              )
            }}
          </Formik>
        </div>
      </div>
    </div>
  )
}

export default RegistrationPage
